import { render, staticRenderFns } from "./UCheckbox.vue?vue&type=template&id=0dbd87c5&scoped=true&"
import script from "./UCheckbox.vue?vue&type=script&lang=js&"
export * from "./UCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UCheckbox.vue?vue&type=style&index=0&id=0dbd87c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd87c5",
  null
  
)

export default component.exports